import { httpRequest } from '@calendly/http-tools'
import { I18n } from '@calendly/i18n'
import { createAsyncThunk } from '@reduxjs/toolkit'

import {
  isSubscriptionPaymentPendingSelector,
  taxInformationModalConfirmedTaxInformationSelector,
} from '../../billing'
import {
  dealSelector,
  cardTokenSelector,
  externalCustomerSelector,
  countryCodeSelector,
  postalCodeSelector,
} from '../selectors'

export const completePayment = createAsyncThunk(
  'payment/complete',
  async (confirmationTokenId, { getState, rejectWithValue }) => {
    const state = getState()
    if (isSubscriptionPaymentPendingSelector(state)) {
      return rejectWithValue(
        I18n.t('publisher.billing.subscription_payment_pending.banner.body')
      )
    }
    const { uuid } = dealSelector(state)
    const cardToken = cardTokenSelector(state)
    const customerId = externalCustomerSelector(state)
    const countryCode = countryCodeSelector(state)
    const postalCode = postalCodeSelector(state)
    const taxInfo = taxInformationModalConfirmedTaxInformationSelector(state)

    let params
    if (confirmationTokenId) {
      params = {
        confirmation_token_id: confirmationTokenId,
        external_customer_id: customerId,
        billing_address: {
          country: countryCode,
          postal_code: postalCode
        },
        tax_info: taxInfo
      }
    } else {
      params = {
        card_token: cardToken,
        external_customer_id: customerId,
        billing_address: {
          country: countryCode,
          postal_code: postalCode
        },
        tax_info: taxInfo
      }
    }

    const [success, response] = await httpRequest({
      url: `/api/billing/deals/${uuid}/redeem`,
      method: 'POST',
      params
    })

    if (!success) {
      return rejectWithValue(
        I18n.t('publisher.components.payment_link.card_declined')
      )
    }

    return response
  }
)
